import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'get-page-metadata' as const;

const argumentZod = z.object({
  pageId: dataToolSchemas.pageId,
  localeId: dataToolSchemas.localeId.optional(),
});

export const getPageMetadataManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get page metadata',
  family: 'pages',
  llmTool: {
    name: toolName,
    description:
      'Gets the metadata for a specific page by ID. Returns page settings including title, slug, SEO settings, and Open Graph data, but excludes page content. Supports locale-specific data.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [
    {
      resource: 'SitePageSettings',
      action: 'read',
      resolveResources: (args) => [{type: 'SitePageSettings', id: args.pageId}],
    },
  ],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetPageMetadataArgumentType = z.infer<typeof argumentZod>;
